/** Номенклатурні групи (одиниці обліку НЗВ) — для вибору у виробничих документах. */
import { api } from './client';

export interface NomenclatureGroup {
  id: string;
  code: string | null;
  name: string;
}

export const nomenclatureGroups = {
  list: () =>
    api.get<NomenclatureGroup[]>('/refs/nomenclature-groups').then((r) => r.data),
};
